























































import {Component, Prop} from 'vue-property-decorator';
import {Mixins} from 'vue-mixin-decorator';
import {BaseComponent} from '@/mixins/BaseComponent';

import {FrequencyPlan} from '@/model/lora/FrequencyPlan';
import {FrequencyPlanChannelType} from '@/model/lora/FrequencyPlanChannelType';

@Component({
  components: {},
})
export default class LoraForwarderFrequencyPlanDetails extends Mixins<BaseComponent>(BaseComponent) {
  private FrequencyPlanChannelType = FrequencyPlanChannelType;

  @Prop(Object)
  private frequencyPlan!: FrequencyPlan;

  private TypeLabels: Map<FrequencyPlanChannelType, string> = new Map<FrequencyPlanChannelType, string>([
    [FrequencyPlanChannelType.Multi, 'MultiSF'],
    [FrequencyPlanChannelType.Fsk, 'FSK'],
    [FrequencyPlanChannelType.Std, 'Standard'],
  ]);
}
